<div class="swaplist flex flex--col flex--nowrap u-p-" [ngStyle]="{ 'height.px': height }">
  <!-- Filters -->
  <div class="flex" id="swap-list-filter-tooltip">
    <div class="u-pr---">{{ 'core.label.filter' | translate }}</div>
    <div [tooltip]="filterTooltip" [disableTooltip]="!filterTooltip" [position]="'right'">
      <svg-icon
        name="ico-info-16"
        [svgStyle]="{ 'width.px': '16', 'height.px': '16', 'fill': 'currentColor' }"
        style="vertical-align: text-top">
      </svg-icon>
    </div>
  </div>
  <div id="swap-list-filters" class="swaplist__filter u-mb-">
    <div id="swap-list-group-by-filter" class="flex flex--col u-pb--" *ngIf="enableGroupByFilter">
      <wfm-virtual-list-dropdown
        [placeholder]="groupByFilterPlaceholder | translate"
        [id]="'user-groups-drop-down'"
        [multiple]="true"
        [items]="groupByItems"
        [searchLabel]="'core.label.search' | translate"
        [isShowSelected]="false"
        [searchIcon]="'ico-search-16'"
        [(value)]="groupByFilterValue"
        (valueChange)="filterItems()">
      </wfm-virtual-list-dropdown>
    </div>
    <div id="swap-list-text-filter" class="flex flex--middle" style="position: relative">
      <input
        id="fromTextFilterItem"
        type="text"
        class="textbox"
        [placeholder]="textFilterPlaceholder | translate"
        [(ngModel)]="filterText"
        (ngModelChange)="filterItems()"
        dir="auto"
      />
      <div class="filter__icon filter__icon--no-event" *ngIf="!filterText">
        <div class="svg-icon__container icon-16">
          <svg-icon
            name="ico-search-16"
            [svgStyle]="{ 'width.px': '16', 'height.px': '16', fill: 'currentColor' }"
          ></svg-icon>
        </div>
      </div>
      <div class="filter__icon icon-16" *ngIf="filterText" (click)="removeFilter()">
        <svg-icon
          name="ico-close-16"
          [svgStyle]="{ 'width.px': '16', 'height.px': '16', fill: 'currentColor' }"
        ></svg-icon>
      </div>
    </div>
  </div>
  <div id="swap-list-contents" class="swaplist__content flex flex--row">
    <!-- From side -->
    <div id="from-container" class="swaplist__side flex flex--col">
      <div class="list-style1__header flex flex--row flex--nowrap flex--justify flex--top u-mb-">
        <!--from header label-->
        <div class="flex flex--row flex--nowrap flex--top flex--left  list-style1__header-text">
          <ng-container *ngIf="fromHeaderLabel !== ''" >
            <div [tooltip]="fromHeaderLabel | translate" [overflowOnly]="true"  class="text-ellipsis">{{fromHeaderLabel | translate}}</div>
            <span>&nbsp;({{fromFilteredItems.length}})</span>
          </ng-container>
        </div>
        <div class="list-style1__select-all-text u-ml----">
          <a [routerLink]=""  class="u-pl no-wrap"
             (click)="selectAll()"
             [class.hyperlink--disabled]="!fromFilteredItems.length"
             *ngIf="!fromFilteredItems.length || fromFilteredItems.length !== fromSelectedItemsMap.size">
            <span>{{ 'core.label.selectAll' | translate }}</span>
          </a>
          <a [routerLink]="" class="u-pl no-wrap"
             (click)="deselectAll()"
             [class.hyperlink--disabled]="!fromSelectedItemsMap.size"
             *ngIf="fromFilteredItems.length > 0 && fromFilteredItems.length === fromSelectedItemsMap.size">
            <span>{{ 'core.label.deselectAll' | translate }}</span>
          </a>
        </div>
      </div>
      <div class="list-style1__items flex flex--col virtual-list-container">
        <div class="virtual-list-scroll-container list-style1__items select__dropdown-panel-items">
          <cdk-virtual-scroll-viewport #fromItemsViewPort itemSize="50"
                                       class="virtual-list-body no-scroll-scrollable"
                                       (scroll)="scrollHandler($event)"
                                       (wheel)="onWheel($event)"
                                       (error)="fromErrorNotify.emit($event)">
            <div class="flex flex--col">
              <div *cdkVirtualFor="let item of fromFilteredItems; index as index" (click)="toggleSelect(item)"
                   [style.max-height.px]="rowHeight"
                   [style.min-height.px]="rowHeight"
                   [class.list-style1__item--selected]="fromSelectedItemsMap.get(item) !== undefined"
                   class="list-style1__item flex flex--row flex--middle" id="swap-list-from-item-{{index}}">
                <svg-icon
                  style="height: 1.6rem"
                  name="ico-checkbox-component-16"
                  [svgStyle]="{ 'width.px': '16', 'height.px': '16', fill: 'currentColor' }"
                  [applyClass]="true"
                  svgClass="swaplist__icon list-style1__item-checkmark"
                >
                </svg-icon>
                <div class="flex flex--row flex--nowrap flex--top flex--left list-style1__item-label no-selectable">
                  <div [tooltip]="!!displayProperty ? item[displayProperty] : item"
                       [overflowOnly]="true"
                       class="text-ellipsis">{{ !!displayProperty ? item[displayProperty] : item }}</div>
                  <span *ngIf="item[groupByPropertyName] && item[groupByPropertyName].length > 1">&nbsp;({{item[groupByPropertyName].length}}&nbsp;{{'core.label.groups' | translate}})</span>
                </div>
              </div>
            </div>
          </cdk-virtual-scroll-viewport>
          <wfm-scrollbar
            *ngIf="scroll.from.verticalScrollSize > scroll.from.verticalOffsetSize && scroll.from.verticalOffsetSize"
            orientation="vertical"
            [offsetSize]="scroll.from.verticalOffsetSize"
            [scrollSize]="scroll.from.verticalScrollSize"
            [arrowIncrement]="rowHeight"
            [position]="scroll.from.verticalScrollPosition"
            (positionChangeEnded)="verticalScrollPositionChange($event)"
          >
          </wfm-scrollbar>
        </div>
      </div>
    </div>

    <!-- Divider -->
    <div id="swap-list-divider" #swapListDivider class="swaplist__list-divider flex flex--col flex--center">
      <button
        id="leftToRight"
        (click)="shuffleItems()"
        type="button"
        class="button button--secondary swaplist__buttonStyle1"
        [disabled]="!fromSelectedItemsMap.size"
      >
        <svg-icon
          name="ico-caret-right-16"
          [svgStyle]="{ 'width.px': '16', 'height.px': '16', fill: 'currentColor' }"
          [applyClass]="true"
          style="height: 1.6rem"
          svgClass="swaplist__icon"
        >
        </svg-icon>
      </button>

      <button
        id="rightToLeft"
        (click)="shuffleItems(true)"
        type="button"
        class="button button--secondary swaplist__buttonStyle1"
        [disabled]="!toSelectedItemsMap.size"
      >
        <svg-icon
          name="ico-caret-left-16"
          [svgStyle]="{ 'width.px': '16', 'height.px': '16', fill: 'currentColor' }"
          [applyClass]="true"
          style="height: 1.6rem"
          svgClass="swaplist__icon"
        >
        </svg-icon>
      </button>
    </div>

    <!-- To side -->
    <div id="to-container" class="swaplist__side flex flex--col">
      <div class="list-style1__header flex flex--row flex--nowrap flex--justify flex--top u-mb-">
        <!--to header label-->
        <div class="flex flex--row flex--nowrap flex--top flex--left  list-style1__header-text">
          <ng-container *ngIf="toHeaderLabel !== ''">
            <div [tooltip]="toHeaderLabel | translate" [overflowOnly]="true"  class="text-ellipsis">{{toHeaderLabel | translate }}</div>
            <span>&nbsp;({{toFilteredItems.length}})</span>
          </ng-container>
        </div>
        <div class="list-style1__select-all-text u-ml----">
          <a [routerLink]=""  class="u-pl no-wrap"
             (click)="selectAll(false)"
             [class.hyperlink--disabled]="!toFilteredItems.length"
             *ngIf="!toFilteredItems.length  || toFilteredItems.length !== toSelectedItemsMap.size">
            <span>{{ 'core.label.selectAll' | translate }}</span>
          </a>
          <a [routerLink]="" class="u-pl no-wrap"
             (click)="deselectAll(false)"
             [class.hyperlink--disabled]="!toSelectedItemsMap.size"
             *ngIf="toFilteredItems.length > 0 && toFilteredItems.length === toSelectedItemsMap.size">
            <span>{{ 'core.label.deselectAll' | translate }}</span>
          </a>
        </div>
      </div>
      <div class="list-style1__items flex flex--col virtual-list-container">
        <div class="virtual-list-scroll-container list-style1__items select__dropdown-panel-items">
          <cdk-virtual-scroll-viewport #toItemsViewPort itemSize="50"
                                       class="virtual-list-body no-scroll-scrollable"
                                       (scroll)="scrollHandler($event, false)"
                                       (wheel)="onWheel($event, false)"
                                       (error)="toErrorNotify.emit($event)">
            <div class="flex flex--col">
              <div *cdkVirtualFor="let item of toFilteredItems; index as index" (click)="toggleSelect(item, true)"
                   [style.max-height.px]="rowHeight"
                   [style.min-height.px]="rowHeight"
                   [class.list-style1__item--selected]="toSelectedItemsMap.get(item) !== undefined"
                   class="list-style1__item flex flex--row flex--middle" id="swap-list-to-item-{{index}}">
                <svg-icon
                  style="height: 1.6rem"
                  name="ico-checkbox-component-16"
                  [svgStyle]="{ 'width.px': '16', 'height.px': '16', fill: 'currentColor' }"
                  [applyClass]="true"
                  svgClass="swaplist__icon list-style1__item-checkmark"
                >
                </svg-icon>
                <div class="flex flex--row flex--nowrap flex--top flex--left list-style1__item-label no-selectable">
                  <div [tooltip]="!!displayProperty ? item[displayProperty] : item"
                       [overflowOnly]="true"
                       class="text-ellipsis">{{ !!displayProperty ? item[displayProperty] : item }}</div>
                  <span *ngIf="item[groupByPropertyName] && item[groupByPropertyName].length > 1">&nbsp;({{item[groupByPropertyName].length}}&nbsp;{{'core.label.groups' | translate}})</span>
                </div>
              </div>
            </div>
          </cdk-virtual-scroll-viewport>
          <wfm-scrollbar
            *ngIf="scroll.to.verticalScrollSize > scroll.to.verticalOffsetSize && scroll.to.verticalOffsetSize"
            orientation="vertical"
            [offsetSize]="scroll.to.verticalOffsetSize"
            [scrollSize]="scroll.to.verticalScrollSize"
            [arrowIncrement]="rowHeight"
            [position]="scroll.to.verticalScrollPosition"
            (positionChangeEnded)="verticalScrollPositionChange($event, false)"
          >
          </wfm-scrollbar>
        </div>
      </div>
    </div>
  </div>
</div>
